import api from './api';

class SlideService {
    getListSlidesOnCheckout(dataForm) {
        return api.post('/get-slides-on-checkout', dataForm);
    }
}

export default new SlideService();
